
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const Navdata = () => {
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState({});
  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  let user = {};

  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    user = {};
  }

  const role = String(user.role || "").trim().toLowerCase();

  const isAdmin = ["admin", "superadmin"].includes(role);
  const isOperationalUser = [
    "staff",
    "counsellor",
    "counselor",
    "supervisor",
  ].includes(role);

  useEffect(() => {
    const pathname = location.pathname;

    if (pathname.startsWith("/leads")) {
      setIscurrentState("Leads");
    } else if (
      pathname.startsWith("/campaigns") ||
      pathname === "/lead-sources" ||
      pathname === "/analytics"
    ) {
      setIscurrentState("Marketing");
    } else if (
      pathname === "/whatsapp" ||
      pathname.startsWith("/conversations")
    ) {
      setIscurrentState("Communications");
    } else if (
      pathname.startsWith("/applications") ||
      pathname === "/admissions"
    ) {
      setIscurrentState("Admissions");
    } else if (pathname.startsWith("/integrations")) {
      setIscurrentState("Integrations");
    } else if (pathname.startsWith("/settings")) {
      setIscurrentState("Settings");
    } else if (pathname.startsWith("/profile")) {
      setIscurrentState("Profile");
    } else {
      setIscurrentState("Dashboard");
    }
  }, [location.pathname]);

  const toggleMenu = (menu) => {
    setOpenMenus((previous) => ({
      ...previous,
      [menu]: !previous[menu],
    }));
  };

  const dashboardItems = [
    { label: "Menu", isHeader: true },
    {
      label: "Dashboard",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
    },
  ];

  const leadMenuItems = [
    { label: "Leads", isHeader: true },
    {
      label: "All Leads",
      icon: "ri-user-search-line",
      link: "/leads",
    },
    {
      label: "New Leads",
      icon: "ri-user-add-line",
      link: "/leads/new",
    },
    {
      label: "Follow-ups",
      icon: "ri-time-line",
      link: "/leads/follow-ups",
    },
    {
      label: "Counselling",
      icon: "ri-chat-3-line",
      link: "/leads/counselling",
    },
  ];

  const communicationMenuItems = [
    { label: "Communications", isHeader: true },
    {
      label: "WhatsApp",
      icon: "ri-whatsapp-line",
      link: "/whatsapp",
    },
    {
      label: "Conversations",
      icon: "ri-message-3-line",
      link: "/conversations",
    },
  ];

  const admissionMenuItems = [
    { label: "Admissions", isHeader: true },
    {
      label: "Applications",
      icon: "ri-file-list-3-line",
      link: "/applications",
    },
    {
      label: "Admissions",
      icon: "ri-graduation-cap-line",
      link: "/admissions",
    },
  ];

  const adminMenuItems = [
    { label: "Marketing", isHeader: true },
    {
      label: "Campaigns",
      icon: "ri-megaphone-line",
      link: "/campaigns",
    },
    {
      label: "Lead Sources",
      icon: "ri-share-forward-line",
      link: "/lead-sources",
    },
    {
      label: "Analytics",
      icon: "ri-bar-chart-box-line",
      link: "/analytics",
    },
    ...communicationMenuItems,
    ...admissionMenuItems,
    { label: "Integrations", isHeader: true },
    {
      label: "Meta",
      icon: "ri-facebook-box-line",
      link: "/integrations/meta",
    },
    {
      label: "Google",
      icon: "ri-google-line",
      link: "/integrations/google",
    },
    {
      label: "YouTube",
      icon: "ri-youtube-line",
      link: "/integrations/youtube",
    },
    {
      label: "WhatsApp Integration",
      icon: "ri-whatsapp-line",
      link: "/integrations/whatsapp",
    },
  ];

  let menuItems;

  if (isAdmin) {
    menuItems = [
      ...dashboardItems,
      ...leadMenuItems,
      ...adminMenuItems,
    ];
  } else if (isOperationalUser) {
    menuItems = [
      ...dashboardItems,
      ...leadMenuItems,
      ...communicationMenuItems,
      ...admissionMenuItems,
    ];
  } else {
    menuItems = [
      ...dashboardItems,
      ...leadMenuItems,
    ];
  }

  function updateIconSidebar(e) {
    if (e?.target?.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      if (!ul) return;

      const iconItems = ul.querySelectorAll(".nav-icon.active");

      [...iconItems].forEach((item) => {
        item.classList.remove("active");

        const id = item.getAttribute("subitems");
        const submenu = document.getElementById(id);

        if (submenu) {
          submenu.classList.remove("show");
        }
      });
    }
  }

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
